import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import axios from "axios";
import {
  StudentmeterialcreateApi,
  StudentmeterialListApi,
  StudentmeterialdeleteApi,
} from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken");

const headers = {
  Authorization: `Bearer ${token}`,
};
// create student
export const createstudent = createAsyncThunk(
  "createstudent/student",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(StudentmeterialcreateApi, data, {
        headers,
      });
      return response.data.message;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // If the server returns an error message
        return rejectWithValue(error.response.data.message);
      } else {
        // If there's an unexpected error
        return rejectWithValue(
          "An unexpected error occurred. Please try again later."
        );
      }
    }
  }
);

// get student
export const getstudent = createAsyncThunk("getstudent/student", async () => {
  try {
    const response = await axios.get(`${StudentmeterialListApi}?limit=`);
    return response.data; 
  } catch (error) {
    throw new Error(error.message);
  }
});

// delete student
export const deletestudents = createAsyncThunk(
  "deletestudents/student",
  async (studentid, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${StudentmeterialdeleteApi}/${studentid}`,
        { headers }
      );
      return response.data._id; 
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const studentSlice = createSlice({
  name: "student",
  initialState: {
    students: [],
    status: "idle",
    error: null,
    message: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //create student
      .addCase(createstudent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createstudent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload;
        if (state.status === "succeeded") {
          toast.success(action.payload);
        }
        state.status = "idle";
      })
      .addCase(createstudent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        if (state.status === "failed") {
          toast.error(action.payload);
        }
      })

      //getstudents
      .addCase(getstudent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getstudent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.students = action.payload;
      })
      .addCase(getstudent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      //delete students
      .addCase(deletestudents.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deletestudents.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.students.data = state.students.data.filter(
          (students) => students.studentid !== action.payload
        );
        state.status = "idle";
      })
      .addCase(deletestudents.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default studentSlice.reducer;
